export type CodeTextPart = { text: string; code: boolean };

export function splitInlineCode(text: string): CodeTextPart[] {
  return text
    .split("`")
    .map((part, index) => ({ text: part, code: index % 2 === 1 }))
    .filter((part) => part.text.length > 0);
}
